<template>
    <v-toolbar-items class="hidden-md-and-down">
        <v-btn v-for="item in menuItems"
               :key="item.title"
               text
               class="font-weight-bold"
               :class="{
        'text-body-1': $vuetify.breakpoint.mdAndDown,
        'text-body-1': $vuetify.breakpoint.lgAndUp,
      }"
               v-if="!item.external"
               :to="item.path">
            {{ item.title }}
        </v-btn>

        <!-- ������� ������ -->
        <v-btn v-else
               text
               class="font-weight-bold"
               :href="item.path"
               target="_blank"
               rel="noopener noreferrer"
               :class="{
        'text-body-1': $vuetify.breakpoint.mdAndDown,
        'text-body-1': $vuetify.breakpoint.lgAndUp,
      }">
            {{ item.title }}
        </v-btn>
    </v-toolbar-items>
</template>

<script>
    export default {
        name: "DefaultMenu",
        props: {
            menuItems: {
                type: Array,
                required: true,
            },
        },
    };
</script>
